/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import PropTypes from "prop-types";
import Logo from "../logo";
import { NavLink } from "react-router-dom";
import { getClosest, getSiblings, slideToggle, slideUp } from "../../utils";

import React, { useState } from "react";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import { useForm } from "react-hook-form";

import axios from "axios";
import cogoToast from "cogo-toast";

const HamburgerMenu = ({ show, onClose }) => {
    const [show1, setShow1] = useState(false);

    const { register, handleSubmit, errors } = useForm({
        mode: "onBlur",
    });

    const handleClose = () => {
        setShow1(false);
    };

    const onSubmit = (data) => {
        // console.log(data);

        axios
            .post("https://soul-house-harmony.onrender.com/admin/login", data)
            .then((res) => {
                console.log(res.data);
                if (res.status === 200) {
                    onClose();
                    sessionStorage.setItem(
                        "admin",
                        JSON.stringify(res.data.admin)
                    );
                    cogoToast.success("Welcome " + res.data.admin.name, {
                        position: "bottom-left",
                    });
                    setShow1(false);
                }
            })
            .catch((err) => {
                console.log(err);
                cogoToast.info("Error submitting form", {
                    position: "bottom-left",
                });
            });
    };

    const logout = () => {
        axios
            .get("https://soul-house-harmony.onrender.com/admin/logout", {
                headers: {
                    Authorization: JSON.parse(sessionStorage.getItem("admin"))
                        .token,
                },
            })
            .then((res) => {
                console.log(res);
                if (res.status === 200) {
                    sessionStorage.removeItem("admin");
                    cogoToast.success("signed out succefully", {
                        position: "bottom-left",
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                cogoToast.info("Error submitting form", {
                    position: "bottom-left",
                });
            });
    };

    const onClickHandler = (e) => {
        const target = e.currentTarget;
        const parentEl = target.parentElement;
        if (
            parentEl?.classList.contains("mobile-menu-expand") ||
            target.classList.contains("mobile-menu-expand")
        ) {
            const element = target.classList.contains("icon")
                ? parentEl
                : target;
            const parent = getClosest(element, "li");
            const childNodes = parent.childNodes;
            const parentSiblings = getSiblings(parent);
            parentSiblings.forEach((sibling) => {
                const sibChildNodes = sibling.childNodes;
                sibChildNodes.forEach((child) => {
                    if (child.nodeName === "UL") {
                        slideUp(child, 1000);
                    }
                });
            });
            childNodes.forEach((child) => {
                if (child.nodeName === "UL") {
                    slideToggle(child, 1000);
                }
            });
        }
    };

    return (
        <>
            <div className={`offcanvas-menu ${show ? "open" : ""}`}>
                <div className="offcanvas-wrapper">
                    <div className="close-btn">
                        <button className="menu-close" onClick={onClose}>
                            <i className="icofont-close-line-circled"></i>
                        </button>
                    </div>
                    <div className="logo">
                        <Logo
                            image={`${process.env.PUBLIC_URL}/images/logo-2.png`}
                        />
                    </div>
                    <div className="primary-menu">
                        <ul>
                            <li>
                                <NavLink exact to="/">
                                    Home
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to={process.env.PUBLIC_URL + "/about"}>
                                    About
                                </NavLink>

                                {/* <span
                                    className="mobile-menu-expand"
                                    onClick={onClickHandler}
                                    aria-hidden="true"
                                ></span>

                                <ul className="sub-menu">
                                    <li>
                                        <NavLink
                                            to={
                                                process.env.PUBLIC_URL +
                                                "/about"
                                            }
                                        >
                                            About Us
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            to={
                                                process.env.PUBLIC_URL +
                                                "/pricing"
                                            }
                                        >
                                            Pricing
                                        </NavLink>
                                    </li>
                                </ul> */}
                            </li>
                            <li>
                                <NavLink
                                    to={process.env.PUBLIC_URL + "/project"}
                                >
                                    Projects
                                </NavLink>

                                <span
                                    className="mobile-menu-expand"
                                    onClick={onClickHandler}
                                    aria-hidden="true"
                                ></span>

                                <ul className="sub-menu">
                                    <li>
                                        <NavLink
                                            to={
                                                process.env.PUBLIC_URL +
                                                "/project"
                                            }
                                        >
                                            Projects
                                        </NavLink>
                                    </li>
                                    {/* <li>
                                        <NavLink
                                            to={
                                                process.env.PUBLIC_URL +
                                                "/project-detalis/1"
                                            }
                                        >
                                            Project Details
                                        </NavLink>
                                    </li> */}
                                    {sessionStorage.getItem("admin") && (
                                        <>
                                            <li>
                                                <NavLink
                                                    to={
                                                        process.env.PUBLIC_URL +
                                                        "/add-project"
                                                    }
                                                >
                                                    Add Project
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink
                                                    to={
                                                        process.env.PUBLIC_URL +
                                                        "/add-project-images"
                                                    }
                                                >
                                                    Add Project Details
                                                </NavLink>
                                            </li>
                                        </>
                                    )}
                                </ul>
                            </li>
                            {/* <li>
                                <NavLink to={process.env.PUBLIC_URL + "/blog"}>
                                    Blog
                                </NavLink>

                                <span
                                    className="mobile-menu-expand"
                                    onClick={onClickHandler}
                                    aria-hidden="true"
                                ></span>

                                <ul className="sub-menu">
                                    <li>
                                        <NavLink
                                            to={
                                                process.env.PUBLIC_URL + "/blog"
                                            }
                                        >
                                            Blog
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            to={
                                                process.env.PUBLIC_URL +
                                                "/blog-details/1"
                                            }
                                        >
                                            Blog Details
                                        </NavLink>
                                    </li>
                                </ul>
                            </li> */}
                            <li>
                                <NavLink
                                    to={process.env.PUBLIC_URL + "/contact"}
                                >
                                    Contact
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={process.env.PUBLIC_URL + "/police"}
                                >
                                    Police
                                </NavLink>
                            </li>

                            {sessionStorage.getItem("admin") ? (
                                <li>
                                    <NavLink
                                        exact
                                        to="/"
                                        onClick={() => {
                                            logout();
                                            onClose();
                                        }}
                                    >
                                        Logout
                                    </NavLink>
                                </li>
                            ) : (
                                <li>
                                    <NavLink
                                        exact
                                        to="/"
                                        onClick={() => {
                                            setShow1(true);
                                            onClose();
                                        }}
                                    >
                                        Admin?
                                    </NavLink>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
            <Modal show={show1} onHide={handleClose}>
                <Modal.Header closeButton style={{ backgroundColor: "black" }}>
                    <Modal.Title>Admin login</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: "black" }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row gx-10">
                            <div className="col-md-12">
                                <div className="single-form">
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="yourmail@domain.com"
                                        ref={register({
                                            required: "Email is required",
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                message:
                                                    "invalid email address",
                                            },
                                        })}
                                    />
                                    {errors.email && (
                                        <p>{errors.email.message}</p>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="single-form">
                                    <input
                                        type="password"
                                        name="password"
                                        placeholder="password"
                                        ref={register({
                                            required: "password is required",
                                        })}
                                    />
                                    {errors.password && (
                                        <p>{errors.password.message}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end gx-10">
                            <div
                                className="form-btn"
                                style={{ marginRight: "20px" }}
                            >
                                <button onClick={handleClose}>Cancel</button>
                            </div>

                            <div className="form-btn">
                                <button type="submit">Submit</button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Save Changes
                    </Button>
                </Modal.Footer> */}
            </Modal>
        </>
    );
};

HamburgerMenu.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
};

export default HamburgerMenu;
